import { render, staticRenderFns } from "./JournalSelect.vue?vue&type=template&id=0f20701e&"
import script from "./JournalSelect.vue?vue&type=script&lang=js&"
export * from "./JournalSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports